import React, {FC, useEffect} from 'react';
import {useLocalizer} from '@/common/services/localizer';
import {UseCookiesRequest} from '@/common/components/UseCookiesRequest';

import {AppHeader} from '../AppHeader';
import {AppFooter} from '../AppFooter';
import {AppConstructor} from '../AppConstructor';
import '@/informers/styles/informers.css';

export const App: FC = () => {
	const t = useLocalizer();

	useEffect(() => {
		document.title = t('documentTitle', {domainName: DOMAIN_NAME.toUpperCase()});
	}, []);

	return (
		<div>
			<AppHeader />
			<AppConstructor />
			<AppFooter />
			{/* <UseCookiesRequest />*/}
		</div>
	);
};

App.displayName = 'App';
